import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { loginGuard } from './shared/guards/login.guard';
import { adminGuard } from './shared/guards/admin.guard';
import { CommentsComponent } from './admin/comments/comments.component';
import { CommentsFeedbackComponent } from './shared/comments/comments.component';
import { SitemapComponent } from './sitemap/sitemap.component';

export const routes: Routes = [
  {
    path: 'home',
    title: 'SIMVet Monitor - Veterinary Education Platform',
    data: {
      breadcrumb: 'Home',
      seo: {
        title: 'SIMVet Monitor - Veterinary Education Platform',
        description:
          'Transform veterinary education with SIMVet Monitor. Master vital signs monitoring through immersive simulations. Real-time monitoring, risk-free practice, and interactive learning for veterinary students.',
        keywords:
          'veterinary education, vital signs monitoring, clinical scenarios, animal patients, SIMVet, veterinary anesthesiology, teaching tool, educational application',
        image: '/assets/carousel/carousel1.png',
        type: 'website',
      },
    },
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/home/home.module').then(m => m.HomeModule),
      },
    ],
  },
  {
    path: 'auth',
    canActivate: [loginGuard],
    data: { breadcrumb: 'Auth' },
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/auth/auth.module').then(m => m.AuthModule),
      },
    ],
  },
  {
    path: 'control-panel',
    canActivate: [authGuard],
    data: { breadcrumb: 'Control Panel' },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@/app/control-panel/control-panel.module').then(m => m.ControlPanelModule),
      },
    ],
  },
  {
    path: 'elearning',
    data: {
      breadcrumb: 'E-Learning',
      seo: {
        title: 'E-Learning Platform - SIMVet Monitor',
        description:
          'Access comprehensive e-learning courses and exams on veterinary vital signs monitoring. Interactive learning modules designed for veterinary students and instructors.',
        keywords:
          'veterinary e-learning, online courses, veterinary education, exam platform, veterinary training',
        image: '/assets/images/monitor-preview.png',
        type: 'website',
      },
    },
    loadChildren: () => import('@/app/elearning/elearning.module').then(m => m.ElearningModule),
  },
  {
    path: 'patients',
    canActivate: [authGuard],
    data: { breadcrumb: 'Patients' },
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/patients/patients.module').then(m => m.PatientsModule),
      },
    ],
  },
  {
    path: 'monitor',
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/monitor/monitor.module').then(m => m.MonitorModule),
      },
    ],
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    data: { breadcrumb: 'Admin' },
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/admin/admin.module').then(m => m.AdminModule),
      },
    ],
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    data: { breadcrumb: 'Profile' },
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/profile/profile.module').then(m => m.ProfileModule),
      },
    ],
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    data: { breadcrumb: 'Notifications' },
    children: [
      {
        path: '',
        loadChildren: () => import('@/app/notifications/notifications.module').then(m => m.NotificationsModule),
      },
    ],
  },
  {
    path: 'comments',
    component: CommentsFeedbackComponent,
    title: 'Peer feedback',
    data: { breadcrumb: 'Comments', animation: 'Thank you for your feedback' },
  },
  {
    path: 'sitemap.xml',
    component: SitemapComponent,
    title: 'Sitemap',
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];
